import { mergeQuoteIntoSeries } from "../liveChartQuotes";
import { createMainSeriesData } from "./lightweightChartUtils";

const sameCandle = (left, right) =>
  left?.time === right?.time &&
  left?.open === right?.open &&
  left?.high === right?.high &&
  left?.low === right?.low &&
  left?.close === right?.close;

export const provisionalCandleExtendsSeries = (
  provisionalCandle,
  authoritativeSeries,
) => {
  const authoritativeCandle = Array.isArray(authoritativeSeries)
    ? authoritativeSeries.at(-1)
    : null;
  return (
    Number.isFinite(Number(provisionalCandle?.time)) &&
    Number.isFinite(Number(authoritativeCandle?.time)) &&
    Number(provisionalCandle.time) > Number(authoritativeCandle.time)
  );
};

export const buildProvisionalLiveCandle = ({
  tickerPrices,
  scale,
  chartViewType,
  assetType,
  livePriceQuote,
  previousProvisionalCandle = null,
  timeZone = null,
}) => {
  if (String(assetType || "").toLowerCase() !== "stocks") return null;
  if (chartViewType === "line" || !livePriceQuote?.provisionalBar) return null;
  if (!livePriceQuote.quoteAtIso) return null;

  const projectedBars = mergeQuoteIntoSeries({
    series: tickerPrices,
    scale,
    price: livePriceQuote.price,
    quoteAtIso: livePriceQuote.quoteAtIso,
    assetType,
  });
  if (projectedBars === tickerPrices) return null;
  const projectedBar = projectedBars.at(-1);
  if (Number(projectedBar?.close) !== Number(livePriceQuote.price)) return null;

  const authoritativeSeries = createMainSeriesData(tickerPrices, timeZone);
  const projectedSeries = createMainSeriesData(projectedBars, timeZone);
  const authoritativeCandle = authoritativeSeries.candleData.at(-1) || null;
  const nextProjectedCandle = projectedSeries.candleData.at(-1) || null;
  const projectedCandle =
    previousProvisionalCandle?.time === nextProjectedCandle?.time
      ? {
          ...nextProjectedCandle,
          high: Math.max(
            Number(nextProjectedCandle.high),
            Number(previousProvisionalCandle.high),
          ),
          low: Math.min(
            Number(nextProjectedCandle.low),
            Number(previousProvisionalCandle.low),
          ),
        }
      : nextProjectedCandle;
  if (!projectedCandle) return null;
  if (
    authoritativeCandle &&
    projectedCandle.time < authoritativeCandle.time
  ) {
    return null;
  }
  if (sameCandle(authoritativeCandle, projectedCandle)) return null;

  return {
    candle: projectedCandle,
    appended:
      !authoritativeCandle || projectedCandle.time > authoritativeCandle.time,
  };
};
